import { BasicInfo, Phase } from '.';

export enum ProjectType {
  SINGLE = 'SINGLE',
  MULTI = 'MULTI',
}

export enum ProjectStatus {
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
  PAUSED = 'PAUSED',
  ACTIVE = 'ACTIVE',
  ENDED = 'ENDED',
  CANCELLED = 'CANCELLED',
}
export interface Project {
  id: number;
  basicInfo: BasicInfo;
  projectName: string;
  projectCode?: string;
  projectImage: FileList;
  startDate: string;
  endDate: string;
  projectLocation?: {
    lat: number;
    lng: number;
  };
  country?: string;
  city?: string;
  area?: string;
  landMark?: string;
  addressDetails?: string;
  projectTypeEnum: ProjectType;
  createdAt: string;
  modifiedAt: string;
  projectImageSize: string;
  projectImageURL: string;
  projectImageFilePath: string;
  projectImageFileName: string;
  projectThumbnailImageSize: string;
  projectThumbnailImageURL: string;
  projectThumbnailImageFilePath: string;
  projectThumbnailImageFileName: string;
  projectStatusEnum: ProjectStatus;
  creatorID: string;
  calculatedStartDate: string;
  calculatedEndDate: string;
  calculatedProgress: number;
  calculatedTeamMembers: number;
  phases: Phase[];
}

export interface ProjectFilters {
  status?: ProjectStatus;
  creatorId?: number;
  startDate?: string;
  endDate?: string;
  sortKey?: string;
  sortDirection?: 'ASC' | 'DESC';
  projectType?: ProjectType;
}

export type PaginatedProject = {
  page: number;
  size?: number;
  projectIdentifier?: string;
} & ProjectFilters;
